<!--有休詳細-->
<template>
  <div>
    <div class="all_area_i0016">
      <div class="search-module_i0016">
      </div>
      <div class="el-detail_i0016">
        <el-row style="padding-bottom: 10px;">
          <table class="i0016-table table-label">
            <!--申請日-->
            <tr>
              <td class="table-header" v-html="$t('MODULE.I0015_LBL_HOLIDAY_APPLY')" 　colspan="3"></td>
            </tr>
            <tr>
              <td class="i0016-form-label" v-html="$t('MODULE.I0015_LBL_APPLY_DATE')"></td>
              <td class="i0016-form-value">
                <el-date-picker :disabled="dateEditable" v-model="yearMonthDay" @blur="dateCheck()" style="width: 94%;font-size:12px;" :editable="false" format="yyyy/MM/dd" value-format="yyyy/MM/dd" :clearable="false" type="date"></el-date-picker>
              </td>
            </tr>
            <!--状態-->
            <tr>
              <td class="i0016-form-label" v-html="$t('MODULE.I0015_LBL_STATE')"></td>
              <td class="i0016-form-value">
                <el-input v-model="statusName" disabled class="i0016-input"></el-input>
              </td>
            </tr>
            <!--承認者-->
            <tr>
              <td class="i0016-form-label" v-html="$t('MODULE.I0015_LBL_ADMINISTRATOR')"></td>
              <td class="i0016-form-value">
                <el-input v-model="user" disabled class="i0016-input"></el-input>
              </td>
            </tr>
            <!--差戻理由-->
            <tr>
              <td class="i0016-form-label" v-html="$t('MODULE.I0016_LBL_REMAND_REASON')"></td>
              <td class="i0016-form-value">
                <el-input v-model="text" disabled type="textarea" maxlength=500 :rows="3" class="input_textarea_i0016"></el-input>
              </td>
            </tr>
          </table>
        </el-row>
      </div>
      <div>
        <el-row style="text-align:center;">
          <!--申請-->
          <el-button v-show="buttonShowable" class="css-btn css-button" type="primary" @click="querySave()" style="margin-top: 8px;font-size: 13px;width:20%">{{$t('COMMON.BTN_APPLY')}}</el-button>
          <!--取消し-->
          <el-button v-show="buttonReadonly" class="css-btn css-button" type="primary" @click="queryCancle()" style="margin-top: 8px;font-size: 13px;width:20%">{{$t('MODULE.I0016_LBL_CANCLE')}}</el-button>
          <!--戻る-->
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 13px;width:20%" @click="back_click">{{$t('COMMON.BTN_BACK')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import css from "@/statics/css"
import * as amsApi from "../api/i_0015"
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  data() {
    return {
      title: '',
      text: '',
      user: '',
      status: '',
      statusName: '',
      yearMonthDay: '',
      updateDate: '',
      buttonShowable: false,
      buttonReadonly: false,
      dateEditable: false
    }
  },
  mounted() {
    this.yearMonthDay = this.timeDefaultDay()
  },
  methods: {
    buttonShowableChange(row) {
      if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '1') {
        this.buttonShowable = true
        this.buttonReadonly = false
      }
      if (row) {
        if (row.status == '0') {
          this.buttonShowable = false
          this.buttonReadonly = true
        } else if (row.status == '1') {
          this.buttonShowable = true
          this.buttonReadonly = true
        } else if (row.status == '3') {
          this.buttonShowable = true
          this.buttonReadonly = false
        }
      }
    },
    dateCheck() {
      if (!this.yearMonthDay) {
        return
      }
      var thisDate = this.timeDefault()
      var inputDate = this.yearMonthDay.substring(0, 7)
      if (inputDate < thisDate) {
        this.$message.error({ message: this.$t('COMMON.MSG_PASTDATE_SELECT'), showClose: true });
        this.yearMonthDay = this.timeDefaultDay()
      }
    },
    timeDefault() {
      var date = new Date();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
      var s1 = curr_year + "/" + curr_month;
      return s1;
    },
    timeDefaultDay() {
      var date = new Date();
      var curr_date = date.getDate();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
      String(curr_date).length < 2 ? (curr_date = "0" + curr_date) : curr_date;
      var s1 = curr_year + "/" + curr_month + "/" + curr_date;
      return s1;
    },
    // 戻る処理
    back_click() {
      this.$router.push({ path: url.routerUrl_I0015, query: { yearOpt: this.$route.query.yearOpt } });
    },
    query() {
      amsApi.i_0015_detail_search(JSON.parse(sessionStorage.getItem('I0015Param')).jobDate).then(response => {
        if (response.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          this.list = []
          //关闭loading
          this.close_loading()
          return
        }
        this.dateEditable = true
        this.yearMonthDay = response.items.holidayDetailSet[0].jobDate;
        this.status = response.items.holidayDetailSet[0].status;
        this.statusName = response.items.holidayDetailSet[0].statusName;
        this.user = response.items.holidayDetailSet[0].approvalUserName;
        this.text = response.items.holidayDetailSet[0].remandReason;
        this.updateDate = response.items.holidayDetailSet[0].updateDate;
        this.buttonShowableChange(response.items.holidayDetailSet[0])
        // doLayout  再加载
        this.table_doLayout()
        //关闭loading
        this.close_loading()
      }).catch((err) => {
        //关闭loading
        this.close_loading()
      });
    },
    //默认作業期間
    timeDefault() {
      var date = new Date();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
      var s1 = curr_year + "/" + curr_month;
      return s1;
    },
    async querySave() {
      if (!this.yearMonthDay) {
        this.$message.error({ message: this.$t('COMMON.MSG_EQUIRED_VALIDITY').replaceAll("{1}", this.$t('MODULE.I0015_LBL_APPLY_DATE')), showClose: true });
        return
      }
      if (this.yearMonthDay.replaceAll('/', '').substring(0, 6) < this.timeDefault().replaceAll('/', '')) {
        this.$message.error({ message: this.$t('COMMON.MSG_PASTDATE_SELECT'), showClose: true });
        return
      }
      // 保存処理
      await this.$confirm(this.$t('COMMON.MSG_SAVE'), {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: 'true'
      }).then(() => {
        var updateDate = ''
        if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '2') {
          updateDate = this.updateDate
        }
        var param = {
          "processDiv": JSON.parse(sessionStorage.getItem('I0016ProcessDiv')),
          "jobDate": this.yearMonthDay,
          "updateDate": updateDate,
        }
        //取得当前用户的用户ID
        var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
        //调用売上保存API
        amsApi.i_0015_update(param, userCd).then(async res => {
          if (res.code == 484) {
            let msg = this.$t('COMMON.' + res.message)
            this.$message.error({ message: msg, showClose: true });
            return
          } else if (res.code == 452) {
            let msg = this.$t('COMMON.' + res.message)
            this.$message.error({ message: msg.replaceAll("{0}", this.$t('MODULE.I0015_LBL_TODAY_APPLY')), showClose: true });
            return
          } else if (res.code == 308) {
            await this.$confirm(this.$t('COMMON.' + res.message), {
              confirmButtonText: this.$t('MODULE.I0013_BTN_YES'),//はい
              cancelButtonText: this.$t('MODULE.I0013_BTN_NO'),//いいえ
              center: 'true'
            }).then(() => {
              this.query()
            }).catch(() => {
              // 取消
            })
            return
          }
          let msg = this.$t('COMMON.' + res.message)
          this.$message.success({ message: msg, showClose: true });
          this.back_click()
        }).catch((err) => {
        });
      }).catch(() => {
        // 取消
      })
    },
    async queryCancle() {
      // 保存処理
      await this.$confirm(this.$t('COMMON.MSG_SAVE'), {//保存しても、よろしいでしょか？
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),//保存
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),//キャンセル
        center: 'true'
      }).then(() => {
        var param = {
          "processDiv": '3',
          "jobDate": this.yearMonthDay,
          "updateDate": this.updateDate,
        }
        //取得当前用户的用户ID
        var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
        //调用売上保存API
        amsApi.i_0015_update(param, userCd).then(async res => {
          if (res.code == 484) {
            let msg = this.$t('COMMON.' + res.message)
            this.$message.error({ message: msg, showClose: true });
            return
          } else if (res.code == 452) {
            let msg = this.$t('COMMON.' + res.message)
            this.$message.error({ message: msg.replaceAll("{0}", this.$t('MODULE.I0015_LBL_TODAY_APPLY')), showClose: true });
            return
          } else if (res.code == 308) {
            await this.$confirm(this.$t('COMMON.' + res.message), {
              confirmButtonText: this.$t('MODULE.I0013_BTN_YES'),//はい
              cancelButtonText: this.$t('MODULE.I0013_BTN_NO'),//いいえ
              center: 'true'
            }).then(() => {
              this.query()
            }).catch(() => {
              // 取消
            })
            return
          }
          let msg = this.$t('COMMON.' + res.message)
          this.$message.success({ message: msg, showClose: true });
          this.back_click()
        }).catch((err) => {
        });
      }).catch(() => {
        // 取消
      })
    },
  },
  // 初期化
  created() {
    this.buttonShowableChange()
    if (JSON.parse(sessionStorage.getItem('I0016ProcessDiv')) === '2') {
      this.query()
    }
  }
}
</script>
<style scope>
/*panel下全部区域*/
.all_area_i0016 {
  margin-left: 0px;
}
/*下半部整体div样式*/
.el-detail_i0016 {
  width: 100%;
  height: 100%;
}
.search-module_i0016 {
  padding-bottom: 1px;
  margin-bottom: 1px; /*检索模块与表格间距*/
  width: 100%;
  background-image: linear-gradient(#ffffff, #ffffff);
}
.i0016-table.el-table td {
  padding: 0px 0;
}
/* 表格边框、字体样式 */
.i0016-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0016-table,
.i0016-table tr td {
  border: 1px solid #ccc;
}
/* 表格内边距 */
.i0016-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0016-form-label {
  text-align: right;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0016-form-value {
  background: #fafafa;
}
/* input框宽度 */
.i0016-input {
  width: 94%;
  font-size: 12px;
}
.input_textarea_i0016 {
  width: 94%;
  min-width: 40%;
  float: left;
  color: #000000;
  vertical-align: top;
}
input:disabled,
textarea:disabled {
  opacity: 1;
  -webkit-text-fill-color: rgb(77, 77, 77);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0016.vue